import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { Button, Text } from "@wojo/ui";
import React from "react";
import { FiX } from "react-icons/fi";
import { useDeparturesStepContext } from "../context/DeparturesStepContext";
import get from "lodash/get";

export const DepartureFiltersHeader: React.FC = () => {
    const { productPage } = useI18n("productPage");
    const { setIsFilterOpen, filterStates } = useDeparturesStepContext();

    return (
        <div
            style={{
                padding: "var(--g-spacing-lg) var(--g-spacing-md)",
                display: "grid",
            }}
        >
            <Text.Heading
                order="3"
                tag="h2"
                style={{
                    marginBottom: "var(--g-spacing-lg)",
                    textAlign: "center",
                }}
            >
                {productPage.tripBuilder.filters.filterScreenTitle.l()}
            </Text.Heading>
            <Button
                adornRight={<FiX aria-hidden />}
                variant="quiet"
                style={{
                    justifySelf: "end",
                }}
                onClick={() => {
                    const filterNames = filterStates.filters?.map(
                        (selectedFilter) =>
                            get(
                                productPage.tripBuilder.filters,
                                selectedFilter,
                            )?.l(),
                    );
                    if (
                        filterStates.departureStartDate ||
                        filterStates.departureEndDate
                    ) {
                        filterNames?.push("Departure Dates (Calendar)");
                    }
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "TRIP_BUILDER",
                            ga4_action: "CLOSE_FILTERS",
                            filterType: "Trip Builder Tour Dates",
                            filteredBy: filterNames?.join("|") || "",
                            filterTripType:
                                filterStates.tripTypes?.join("|") || "",
                        },
                    });
                    setIsFilterOpen?.(false);
                }}
            >
                Close
            </Button>
        </div>
    );
};
